module.exports = __webpack_public_path__ + "img/crying_cat.254498ea.png";